"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcePurpose = exports.ResourceType = exports.Resource = void 0;
class Resource {
    getBlob() {
        return this.resourceBody;
    }
}
exports.Resource = Resource;
var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Blob"] = 0] = "Blob";
    ResourceType[ResourceType["Url"] = 1] = "Url";
})(ResourceType = exports.ResourceType || (exports.ResourceType = {}));
var ResourcePurpose;
(function (ResourcePurpose) {
    ResourcePurpose[ResourcePurpose["Image"] = 0] = "Image";
    ResourcePurpose[ResourcePurpose["Song"] = 1] = "Song";
})(ResourcePurpose = exports.ResourcePurpose || (exports.ResourcePurpose = {}));
//# sourceMappingURL=Resource.js.map